// extracted by mini-css-extract-plugin
export default {"root":"AddOnsList_root__JKAhL","list":"AddOnsList_list__mo-Pv"};